import React from "react";
import {
  Modal,
  Box,
  IconButton,
  Typography,
  Button,
  Divider,
  CircularProgress
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import InfiniteScroll from "react-infinite-scroll-component";
import defaultProjectImage from "../../assets/images/placeholder_img.jpg";
import { getFormattedAddress } from "./GetFormattedAddress";
import { BIBlue } from "../../assets/helpers";

const getFullAddress = (params) => {
  if (!params) return "";
  return getFormattedAddress(
    params.address || "",
    "",
    params.city || "",
    params.province || "",
    params.country || "",
    params.postalCode || "",
    3
  );
};

const SelectSite = ({
  open,
  onClose,
  address,
  siteCandidates,
  hasMore,
  onSiteSelect,
  onLoadMore,
  onAddNewOpen,
}) => {

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        className="user-modal-responsive"
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          maxHeight: "90vh",
          width: "95%",
          maxWidth: "600px",
          bgcolor: "background.paper",
          boxShadow: 24,
          display: "flex",
          flexDirection: "column",
          padding: "0px !important",
          borderRadius: "12px",
          overflow: "hidden"
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            p: 2,
            borderBottom: "1px solid #f1f5f9",
            bgcolor: "white"
          }}
        >
          <IconButton onClick={onClose} size="small">
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h6" sx={{ fontWeight: 700 }}>Select or Add a Site</Typography>
        </Box>

        {/* Address chip */}
        <Box sx={{ px: 2, pt: 2, pb: 1, bgcolor: "white" }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              bgcolor: "#EEF2FF",
              borderRadius: "10px",
              px: 1.5,
              py: 1.2,
              gap: 1
            }}
          >
            <LocationOnIcon sx={{ color: "#083DB8", fontSize: 20, flexShrink: 0 }} />
            <Typography variant="body2" sx={{color: "#083DB8",  fontWeight: 600 }}  noWrap>
              {getFullAddress(address)}
            </Typography>
          </Box>
        </Box>

        {/* Site list */}
        <div
          id="select-site-scroll"
          style={{ height: "calc(90vh - 200px)", overflow: "auto", scrollbarWidth: "none" }}
        >
        <InfiniteScroll
          dataLength={siteCandidates.length}
          next={onLoadMore}
          hasMore={hasMore}
          loader={
            <Box sx={{ p: 2, textAlign: "center" }}>
              <CircularProgress size={24} />
            </Box>
          }
          scrollableTarget="select-site-scroll"
        >
          {siteCandidates.length > 0 && (
            <Typography
              variant="caption"
              sx={{ px: 2, pt: 1.5, pb: 0.5, display: "block", color: "text.secondary", letterSpacing: "0.08em", fontWeight: 600 }}
            >
              SITES FOUND AT THIS ADDRESS
            </Typography>
          )}

          {siteCandidates.map((site) => (
            <Box key={site.id}>
              <Box
                onClick={() => onSiteSelect(site)}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  px: 2,
                  py: 1.5,
                  cursor: "pointer",
                  "&:hover": { bgcolor: "#f8fafc" }
                }}
              >
                <Box
                  sx={{
                    width: 60,
                    height: 60,
                    flexShrink: 0,
                    borderRadius: "8px",
                    overflow: "hidden",
                    bgcolor: "#f1f5f9"
                  }}
                >
                  <img
                    src={site.mainPictureUrl || site.pictureUrl || defaultProjectImage}
                    alt={site.name}
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                    onError={(e) => { e.target.src = defaultProjectImage; }}
                  />
                </Box>
                <Box sx={{ flex: 1, mx: 1.5, overflow: "hidden" }}>
                  <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                    {site.name || "Unnamed Site"}
                  </Typography>
                  <Typography
                    variant="caption"
                    
                    sx={{color: "text.secondary", 
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden"
                    }}
                  >
                    {site.address || getFullAddress(address)}
                  </Typography>
                </Box>
                <ChevronRightIcon sx={{ color: "#bdbdbd", flexShrink: 0 }} />
              </Box>
              <Divider />
            </Box>
          ))}
          </InfiniteScroll>

          {siteCandidates.length === 0 && (
            <Box sx={{ p: 3, textAlign: "center" }}>
              <Typography variant="body2" sx={{ color: "text.secondary" }}>
                No existing sites found at this address.
              </Typography>
            </Box>
          )}

        </div>

        {/* Add New Site sticky button */}
        <Box sx={{ p: 2, borderTop: "1px solid #f1f5f9", bgcolor: "white" }}>
          <Button
            variant="contained"
            fullWidth
            startIcon={<AddCircleIcon />}
            sx={{
              borderRadius: "10px",
              py: 1.5,
              bgcolor: "#083DB8",
              "&:hover": { bgcolor: BIBlue },
              textTransform: "none",
              fontWeight: 700,
              fontSize: "1rem"
            }}
            onClick={onAddNewOpen}
          >
            Add New Site
          </Button>
        </Box>

      </Box>
    </Modal>
  );
};

export default SelectSite;
